var map = {
	"./BG": [
		9047,
		842
	],
	"./BG.vue": [
		9047,
		842
	],
	"./Contact": [
		6382,
		114,
		382,
		9
	],
	"./Contact.vue": [
		6382,
		114,
		382,
		9
	],
	"./EpicFail": [
		9207,
		532
	],
	"./EpicFail.vue": [
		9207,
		532
	],
	"./Footer": [
		3246,
		798
	],
	"./Footer.vue": [
		3246,
		798
	],
	"./Header": [
		3886,
		456
	],
	"./Header.vue": [
		3886,
		456
	],
	"./Home": [
		8962,
		114,
		474,
		673,
		583,
		153,
		382,
		274
	],
	"./Home.vue": [
		8962,
		114,
		474,
		673,
		583,
		153,
		382,
		274
	],
	"./Introduction": [
		9153,
		474,
		153,
		283
	],
	"./Introduction.vue": [
		9153,
		474,
		153,
		283
	],
	"./Lottie": [
		2421,
		474
	],
	"./Lottie.vue": [
		2421,
		474
	],
	"./Navigation": [
		2896,
		313
	],
	"./Navigation.vue": [
		2896,
		313
	],
	"./NotFound": [
		2358,
		810
	],
	"./NotFound.vue": [
		2358,
		810
	],
	"./Project": [
		8737,
		114,
		673,
		994
	],
	"./Project.vue": [
		8737,
		114,
		673,
		994
	],
	"./Reel": [
		3509,
		114,
		747
	],
	"./Reel.vue": [
		3509,
		114,
		747
	],
	"./Studio": [
		6940,
		361
	],
	"./Studio.vue": [
		6940,
		361
	],
	"./Thanks": [
		478,
		0
	],
	"./Thanks.vue": [
		478,
		0
	],
	"./Work": [
		8583,
		673,
		583,
		8
	],
	"./Work.vue": [
		8583,
		673,
		583,
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8836;
module.exports = webpackAsyncContext;